export default __webpack_public_path__ + "assets/b7f246046e0e003ccaa245427a590d57.png";